import axios from "axios";
import { SessionHelper } from "../utilities/sessionHelper";

let uchiApi;
let vueRouter;

export default {
  async get(path, config) {
    if (!uchiApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    return await uchiApi.get(path, config);
  },

  async post(path, data, config) {
    if (!uchiApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    return await uchiApi.post(path, data, config);
  },

  async put(path, data, config) {
    if (!uchiApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    return await uchiApi.put(path, data, config);
  },

  async patch(path, data, config) {
    if (!uchiApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    return await uchiApi.patch(path, data, config);
  },

  async delete(path, config) {
    if (!uchiApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    return await uchiApi.delete(path, config);
  },

  async spread(fns) {
    return uchiApi.spread(fns);
  },

  init(router) {
    vueRouter = router;

    uchiApi = axios.create({
      baseURL: import.meta.env.VITE_APP_UCHI_API_ENDPOINT
    });

    uchiApi.interceptors.request.use(config => {
      config.headers["Authorization"] = "Bearer " + SessionHelper.nctSessionToken();
      config.headers["RouteName"] = vueRouter.currentRoute.name;
      config.headers["x-functions-key"] = import.meta.env.VITE_APP_UCHI_FUNCTION_KEY;
      return config;
    });

    uchiApi.interceptors.response.use(undefined, error => {
      switch (error.response.status) {
        case 401:
          //sessionLogout();
          break;

        default:
          break;
      }
      return Promise.reject(error);
    });
  }
};
